<template>
  <div class="map-right-layers-item-service map-right-layers-item-service__container">
    <div class="map-right-layers-item-service__title">
      <span
        class="
          material-icons
          map-right-layers-item-service__title__icon-arrow
        "
        @click="toggleExpanded"
      >
        {{ isExpanded ? 'expand_more' : 'chevron_right' }}
      </span>
      <Checkbox
        v-model="isVisibleRef"
        :binary="true"
        @click="toggleAllLayersVisibles"
      />
      <span class="map-right-layers-item-service__title__label">
        {{ props___.layer.getProperties().name }}
      </span>
      <span
        class="
          material-icons
          map-right-layers-item-service__title__icon-trash
        "
        @click="remove"
      >
        delete_outline
      </span>
    </div>
    <div
      v-if="isExpanded"
      class="map-right-layers-item-service__content"
    >
      <Item
        v-for="(item, key) in props___.layer.getLayers().getArray()"
        :key="item.getProperties().name"
        :layer="item"
        @click-delete="onClickDeleteItem"
        @toggle-visible="() => checkAllItemsVisibles(key)"
      >
        {{ key + randomString() }}
      </Item>
    </div>
  </div>
</template>


<script setup>
// vue
import {ref} from 'vue';

// Primevue
import Checkbox from 'primevue/checkbox';

// component
import Item from './MapRight.Layers.Item-Service.List.vue';

// composables
import randomString from '@/composables/random-string/random-string';

// #region Props, Emits
const props___ = defineProps({
  layer: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits(['click-delete']);
// #endregion


// #region Params, Ref, Reactives, Computed
const isExpanded = ref(true);
const isVisibleRef = ref(false);
// #endregion


// #region Functions
function toggleExpanded() {
  isExpanded.value = !isExpanded.value;
}

function checkAllItemsVisibles() {
  let anyNoVisible = false;

  for (const layer of props___.layer.getLayers().getArray()) {
    if (!layer.getVisible()) {
      anyNoVisible = true;
      break;
    }
  }
  isVisibleRef.value = !anyNoVisible;
}

function onClickDeleteItem(index) {
  const layer = props___.layer.getLayers().getArray().splice(index, 1);
  layer[0].setVisible(false);
}

function toggleAllLayersVisibles() {
  const newValue = !isVisibleRef.value;
  props___.layer.getLayers().getArray().forEach((layer) => {
    layer.setVisible(newValue);
  });
  isVisibleRef.value = newValue;
}

function remove() {
  emits('click-delete');
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-item-service {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__title {
    display: flex;
    align-items: center;
    border-bottom: 1px solid $brand__color--blue;
    margin: 5px 0;

    &__icon-arrow {
      cursor: pointer;
    }

    &__label {
      flex: 1 1 100%;
      padding: 5px;
      font-weight: bold;
    }

    &__icon-trash {
      cursor: pointer;
      color: $brand__color--red;
    }
  }

  &__content {
    margin-left: 25px;
  }

}
</style>
